import { create } from 'zustand';
import type { PrintDoc, PrintSize } from './print-types';

export interface PrintJob {
  doc: PrintDoc;
  size: PrintSize;
  data: unknown;
}

/** A job on the layer. The id changes on every start, so the document remounts and signals ready again. */
export interface ActivePrintJob extends PrintJob {
  id: number;
}

let nextJobId = 1;

interface PrintState {
  job: ActivePrintJob | null;
  /** True once the host has rendered the job, fonts are loaded and barcodes are drawn. */
  ready: boolean;
  start: (job: PrintJob) => void;
  markReady: () => void;
  clear: () => void;
}

/** UI state only: which document is on the print layer right now. */
export const usePrintStore = create<PrintState>((set) => ({
  job: null,
  ready: false,
  start: (job) => { set({ job: { ...job, id: nextJobId++ }, ready: false }); },
  markReady: () => { set((s) => (s.job === null ? s : { ready: true })); },
  clear: () => { set({ job: null, ready: false }); },
}));
